import React, { useState } from "react";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import api from "../../api";

import "../Login.css"; // চাইলে আলাদা css, না হলে school এরটা reuse করো

export default function SuperAdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const togglePasswordVisibility = () => setShowPassword((s) => !s);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!email) {
      setError("Email is required");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("/super_admin/login", { email, password });
      const data = res.data;

      if (data.status) {
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("id", data.data.id);
        localStorage.setItem("name", data.data.name);
        localStorage.setItem("role", data.data.role); // always "super_admin"
        localStorage.setItem("userType", "platform"); // 🚩 clear distinction

          // 🚩 Clear school-related storage for platform super_admin
        localStorage.removeItem("school_id");
        localStorage.removeItem("schools");

        await Swal.fire({
          icon: "success",
          title: "Login Successful!",
          text: `Welcome, ${data.data.name}`,
          timer: 1500,
          showConfirmButton: false,
        });

        navigate("/super_admin/dashboard");
      } else {
        setError(data.message || "Login failed");
      }
    } catch (err) {
      console.error("Super Admin Login Error:", err);
      setError("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleLogin}>
        <h2>🛠 Platform Super Admin Login</h2>
        <p className="subtitle">System Owner Access</p>

        {error && <p className="error-msg">{error}</p>}

        <div className="input-group">
          <FaUser className="icon" />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="input-group">
          <FaLock className="icon" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {showPassword ? (
            <FaEyeSlash className="toggle-eye" onClick={togglePasswordVisibility} />
          ) : (
            <FaEye className="toggle-eye" onClick={togglePasswordVisibility} />
          )}
        </div>

        <button className="login-btn" type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}
